import axios from 'axios';

const approveRequests = (requests) => {
  return axios.post('/api/budgeter/approve-requests', {requests});
};

const rejectRequests = (requests) => {
  return axios.post('/api/budgeter/reject-requests', {requests});
};

const unDecideRequests = (requests) => {
  return axios.post('/api/budgeter/pend-requests', {requests});
};

const getRequestSummary = (budgetId, accountTypeId, appliedFilters) => {
  return axios.post('/api/budgeter/request-summary', {
    budgetId,
    accountTypeId,
    appliedFilters,
  });
};

const getRequests = (budgetId, paginationData, sortBy, appliedFilters, searchKeywords) => {
  return axios.post(`/api/budgeter/item-requests/${budgetId}`, {
    paginationData,
    appliedFilters,
    sortBy,
    searchKeywords,
  });
};

const getItemRequestById = (itemRequestId) => {
  return axios.get('/api/budgeter/item-requests/get-item-request-by-id', {
    params: {
      itemRequestId
    }
  });
};

const getRequestMainInfo = (requestId) => {
  return axios.get('/api/budgeter/request-main-info', {
    params: {
      requestId: requestId
    }
  });
};

const getRequestQuestionAnswersAndBoxChoices = (requestId) => {
  return axios.get('/api/budgeter/request-question-answers-and-box-choices', {
    params: {
      requestId: requestId
    }
  });
};

const getRequestComments = (requestId) => {
  return axios.get('/api/budgeter/request-comments', {
    params: {
      requestId: requestId
    }
  });
};

const getRequestMetaItem = (itemRequestId) => {
  return axios.get('/api/budgeter/item-requests/meta-item', {
    params: {
      itemRequestId: itemRequestId
    }
  });
};

const createComment = (comment, independently = false) => {
  return axios.post('/api/budgeter/create-comment', { comment, independently });
};

const deleteComment = (commentId) => {
  return axios.delete('/api/budgeter/delete-comment', {
    data: { commentId }
  });
};

const updateComment = (commentId, commentText) => {
  return axios.post('/api/budgeter/update-comment', {
    commentId: commentId,
    commentText: commentText
  });
};

const updateQuestionAnswers = (formData) => {
  return axios.post('/api/budgeter/question-answers', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

const getItemById = (itemId) => {
  return axios.get(`/api/budgeter/item-by-id/${itemId}`, {
  });
};

const createRequest = (request) => {
  return axios.post('/api/budgeter/create-request',request, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

const validateItems = (items) => {
  return axios.post('/api/budgeter/validate-items', {
    items
  });
};

const deleteRequests = (ids) => {
  return axios.delete('/api/budgeter/delete-requests', {
    data: { ids }
  });
};

const editRequest = (requestBody) => {
  return axios.post('/api/budgeter/update-request', requestBody, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

const editRequestItem = (requestItemBody) => {
  return axios.post('/api/budgeter/update-request/meta-item', {
    requestItemBody
  });
};

const getItemsForBudget = (budgetId, appliedFilters, accountTypeId, paginationData, sortBy, searchKeywords, requestType) => {
  return axios.post('/api/budgeter/items', {
    budgetId,
    accountTypeId,
    appliedFilters,
    paginationData,
    sortBy,
    searchKeywords,
    requestType,
  });
};

const getItemsBasicInfoByBudgetId = (budgetId) => {
  return axios.get(`/api/budgeter/items-basic-info/${budgetId}`);
};

const getBudgeterOrganizationLevels = () => {
  return axios.get('/api/budgeter/get-budgeter-organization-levels');
};

const getBudgeterObjectCategoryTypes = (objectTypeId) => {
  return axios.get(`/api/budgeter/get-budgeter-category-types/${objectTypeId}`);
};

const getAllocationBaselineBudget = (referenceBudgetId) => {
  return axios.post('/api/budgeter/get-allocation-baseline-budget', {
    referenceBudgetId,
  });
};

const saveNewBaselineBudget = (referenceBudgetId, newBaselineBudgetId) => {
  return axios.post('/api/budgeter/save-new-baseline-budget', {
    referenceBudgetId,
    newBaselineBudgetId
  });
};


const getAllocationsByItemId = (budgetId, itemId) => {
  return axios.post('/api/budgeter/allocations-by-item-id', {
    budgetId,
    itemId
  });
};

const getBudgetImpactTabData = (requestId) => {
  return axios.get('/api/budgeter/budget-impact',{
    params: {
      requestId
    }
  });
};

const getRequestGroupNames = (budgetId) => {
  return axios.get('/api/budgeter/request-group-names', {
    params: {
      budgetId
    }
  });
};

const createRequestGroup = (data) => {
  return axios.post('/api/budgeter/create-request-group', {
    ...data
  });
};

const getRequestGroups = (budgetId, appliedFilters) => {
  return axios.post('/api/budgeter/request-groups', {
    budgetId,
    appliedFilters
  });
};
const getReallocationOpportunities = (budgetId, accountTypeId, appliedFilters) => {
  return axios.post('/api/budgeter/get-reallocation-opportunities', {
    budgetId,
    accountTypeId,
    appliedFilters
  });
};

const unGroupRequests = (ids) => {
  return axios.post('/api/budgeter/ungroup-requests', {groupIds: ids});
};

const approveGroups = (ids) => {
  return axios.post('/api/budgeter/approve-request-groups', { groupIds: ids });
};

const rejectGroups = (ids) => {
  return axios.post('/api/budgeter/reject-request-groups', { groupIds: ids });
};

const unDecideGroups = (ids) => {
  return axios.post('/api/budgeter/pend-request-groups', { groupIds: ids });
};

const getBudgeterPhase = (budgetId) => {
  return axios.get('/api/budgeter/get-budgeter-phase', {
    params: {
      budgetId,
    },
  });
};

const setBudgeterPhase = (budgetId, budgeterPhase) => {
  return axios.post('/api/budgeter/set-budgeter-phase', { 
    budgetId,
    budgeterPhase
  });
};

const getBudgeterFTEChanges = () => {
  return axios.get('/api/budgeter/get-budgeter-fte-changes');
};

const setBudgeterFTEChanges = (fteChanges) => {
  return axios.post('/api/budgeter/set-budgeter-fte-changes', { 
    fteChanges
  });
};

const updateQuestionAnswersAndBoxChoices = (formData) => {
  return axios.post('/api/budgeter/update-question-answers-and-box-choices', 
    formData, 
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
};



const getBoxChoices = () => {
  return axios.get('/api/budget-requests/boxchoices');
};

const deleteBoxChoice = (data, config) => {
  return axios.delete('/api/budget-requests/boxchoices', { data: data, ...config });
};

const updateBoxChoiceType = (data) => {
  return axios.post('/api/budget-requests/boxchoice-type/forge', data);
};

const deleteBoxChoiceType = (data, config) => {
  return axios.delete('/api/budget-requests/boxchoice-types', { data: data, ...config });
};

const getQuestions = () => {
  return axios.get('/api/budget-requests/questions');
};

const getAdditionalQuestion = () => {
  return axios.get('/api/budget-requests/questions/additional');
};

const updateQuestions = (data, questionTypeId) => {
  return axios.post('/api/budget-requests/questions/forge', { data: data, questionTypeId });
};

const updateAdditionalQuestion = (data) => {
  return axios.post('/api/budget-requests/questions/additional/forge', data);
};

const deleteRequest = (requestId, requestType) => {
  return axios.delete('/api/budget-requests/delete-request', {
    data: {
      id: requestId,
      requestType: requestType,
    },
  });
};


export {
  approveRequests,
  rejectRequests,
  unDecideRequests,
  getRequestSummary,
  getRequests,
  getItemRequestById,
  getRequestMainInfo,
  getRequestQuestionAnswersAndBoxChoices,
  getRequestComments,
  getRequestMetaItem,
  createComment,
  deleteComment,
  updateComment,
  updateQuestionAnswers,
  getItemById,
  createRequest,
  deleteRequests,
  editRequest,
  editRequestItem,
  getItemsForBudget,
  getItemsBasicInfoByBudgetId,
  getBudgeterOrganizationLevels,
  getBudgeterObjectCategoryTypes,
  getAllocationBaselineBudget,
  saveNewBaselineBudget,
  getAllocationsByItemId,
  getBudgetImpactTabData,
  getRequestGroupNames,
  createRequestGroup,
  getRequestGroups,
  unGroupRequests,
  approveGroups,
  rejectGroups,
  unDecideGroups,
  getReallocationOpportunities,
  getBudgeterPhase,
  setBudgeterPhase,
  getBudgeterFTEChanges,
  setBudgeterFTEChanges,
  validateItems,
  updateQuestionAnswersAndBoxChoices,
  getBoxChoices,
  deleteBoxChoice,
  updateBoxChoiceType,
  deleteBoxChoiceType,
  getQuestions,
  getAdditionalQuestion,
  updateQuestions,
  updateAdditionalQuestion,
  deleteRequest,
};
